import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "space-y-6 px-3 sm:px-6 lg:col-span-full lg:px-0" }
const _hoisted_2 = {
  key: 0,
  class: "relative sm:border-b border-gray-200"
}
const _hoisted_3 = {
  key: 2,
  class: "relative sm:border-b border-gray-200"
}
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "grid grid-cols-1 sm:hidden" }
const _hoisted_6 = { class: "flex flex-1 flex-col" }
const _hoisted_7 = {
  role: "list",
  class: "-mx-2 space-y-1"
}
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 0,
  class: "ml-auto w-9 min-w-max rounded-full bg-white px-2.5 py-0.5 text-center text-xs/5 font-medium whitespace-nowrap text-gray-600 ring-1 ring-gray-200 ring-inset",
  "aria-hidden": "true"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = { class: "hidden sm:block" }
const _hoisted_15 = { class: "-mb-px flex space-x-4 overflow-x-auto lg:overflow-x-hidden" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = ["href"]
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = { class: "ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShareGalleryModalComponent = _resolveComponent("ShareGalleryModalComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.gallery)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[1] || (_cache[1] = [
          _createStaticVNode("<div class=\"mt-4\" data-v-1698a9fe><div class=\"grid grid-cols-1 sm:hidden space-y-2\" data-v-1698a9fe><div class=\"skeleton h-6 w-1/2 rounded\" data-v-1698a9fe></div><div class=\"skeleton h-6 w-1/3 rounded\" data-v-1698a9fe></div><div class=\"skeleton h-6 w-1/4 rounded\" data-v-1698a9fe></div><div class=\"skeleton h-6 w-1/3 rounded\" data-v-1698a9fe></div></div><div class=\"hidden sm:block\" data-v-1698a9fe><div class=\"flex space-x-4 mb-2 overflow-x-auto lg:overflow-x-hidden\" data-v-1698a9fe><div class=\"skeleton h-6 w-20 rounded\" data-v-1698a9fe></div><div class=\"skeleton h-6 w-20 rounded\" data-v-1698a9fe></div><div class=\"skeleton h-6 w-20 rounded\" data-v-1698a9fe></div><div class=\"skeleton h-6 w-20 rounded\" data-v-1698a9fe></div></div></div></div>", 1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.gallery && _ctx.gallery.public_url)
      ? (_openBlock(), _createBlock(_component_ShareGalleryModalComponent, {
          key: 1,
          open: _ctx.showShareModal,
          url: _ctx.gallery.public_url,
          "qr-url": _ctx.publicUrl(`qr-code/share?size=500&url=${_ctx.gallery.public_url}`),
          name: _ctx.gallery.name,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showShareModal = false))
        }, null, 8, ["open", "url", "qr-url", "name"]))
      : _createCommentVNode("", true),
    (_ctx.gallery)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("nav", _hoisted_6, [
                _createElementVNode("ul", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: tab.name
                    }, [
                      (!tab.external)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: tab.href,
                            class: _normalizeClass([tab.current ? 'bg-gray-50 outline-1 outline-gray-200 text-royal-blue-600' : 'text-gray-700 hover:bg-gray-50 hover:text-royal-blue-600', 'group flex items-center gap-x-2 rounded-md p-2 text-sm/6 font-semibold'])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                src: tab.icon,
                                alt: tab.name,
                                class: _normalizeClass([tab.current ? 'text-royal-blue-600' : 'text-gray-400 group-hover:text-royal-blue-600', 'size-5 shrink-0']),
                                "aria-hidden": "true"
                              }, null, 10, _hoisted_8),
                              _createTextVNode(" " + _toDisplayString(tab.name) + " ", 1),
                              (tab.count)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(tab.count), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["to", "class"]))
                        : _createCommentVNode("", true),
                      (tab.external && !tab.actionable)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: tab.href,
                            target: "_blank",
                            class: _normalizeClass(['text-gray-700 hover:bg-gray-50 hover:text-royal-blue-600', 'group flex items-center gap-x-2 rounded-md p-2 text-sm/6 font-semibold'])
                          }, [
                            _createElementVNode("img", {
                              src: tab.icon,
                              alt: tab.name,
                              class: _normalizeClass([tab.current ? 'text-royal-blue-600' : 'text-gray-400 group-hover:text-royal-blue-600', 'size-5 shrink-0']),
                              "aria-hidden": "true"
                            }, null, 10, _hoisted_11),
                            _createTextVNode(" " + _toDisplayString(tab.name), 1)
                          ], 8, _hoisted_10))
                        : _createCommentVNode("", true),
                      (tab.external && tab.actionable)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            href: "#",
                            onClick: _withModifiers(tab.action, ["prevent"]),
                            class: _normalizeClass(['text-gray-700 hover:bg-gray-50 hover:text-royal-blue-600', 'group flex items-center gap-x-2 rounded-md p-2 text-sm/6 font-semibold'])
                          }, [
                            _createElementVNode("img", {
                              src: tab.icon,
                              alt: tab.name,
                              class: _normalizeClass([tab.current ? 'text-royal-blue-600' : 'text-gray-400 group-hover:text-royal-blue-600', 'size-5 shrink-0']),
                              "aria-hidden": "true"
                            }, null, 10, _hoisted_13),
                            _createTextVNode(" " + _toDisplayString(tab.name), 1)
                          ], 8, _hoisted_12))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("nav", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: tab.name
                  }, [
                    (!tab.external)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: tab.href,
                          class: _normalizeClass([tab.current ? 'border-blue-600 text-blue-700' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700', 'border-b-2 px-1 pb-4 text-sm font-medium whitespace-nowrap flex items-center gap-1.5']),
                          "aria-current": tab.current ? 'page' : undefined
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: tab.icon,
                              alt: tab.name,
                              class: _normalizeClass([tab.current ? 'text-royal-blue-600' : 'text-gray-400 group-hover:text-royal-blue-600', 'size-5 shrink-0']),
                              "aria-hidden": "true"
                            }, null, 10, _hoisted_16),
                            _createTextVNode(" " + _toDisplayString(tab.name) + " ", 1),
                            (tab.count)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass([tab.current ? 'bg-blue-100 text-royal-blue-500' : 'bg-gray-200 text-gray-900', 'ml-3 hidden rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block'])
                                }, _toDisplayString(tab.count), 3))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["to", "class", "aria-current"]))
                      : _createCommentVNode("", true),
                    (tab.external && !tab.actionable)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: tab.href,
                          target: "_blank",
                          class: _normalizeClass(['border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700', 'border-b-2 px-1 pb-4 text-sm font-medium whitespace-nowrap flex items-center gap-1.5'])
                        }, [
                          _createElementVNode("img", {
                            src: tab.icon,
                            alt: tab.name,
                            class: _normalizeClass([tab.current ? 'text-royal-blue-600' : 'text-gray-400 group-hover:text-royal-blue-600', 'size-5 shrink-0']),
                            "aria-hidden": "true"
                          }, null, 10, _hoisted_18),
                          _createTextVNode(" " + _toDisplayString(tab.name), 1)
                        ], 8, _hoisted_17))
                      : _createCommentVNode("", true),
                    (tab.external && tab.actionable)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 2,
                          href: "#",
                          onClick: _withModifiers(tab.action, ["prevent"]),
                          class: _normalizeClass(['border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700', 'border-b-2 px-1 pb-4 text-sm font-medium whitespace-nowrap flex items-center gap-1.5'])
                        }, [
                          _createElementVNode("img", {
                            src: tab.icon,
                            alt: tab.name,
                            class: _normalizeClass([tab.current ? 'text-royal-blue-600' : 'text-gray-400 group-hover:text-royal-blue-600', 'size-5 shrink-0']),
                            "aria-hidden": "true"
                          }, null, 10, _hoisted_20)
                        ], 8, _hoisted_19))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                (_ctx.isCurrentGallery)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/subscription",
                      class: _normalizeClass(['border-transparent text-blue-700 hover:border-gray-300 hover:text-blue-600', 'ml-auto border-b-2 px-1 pb-4 text-sm font-medium whitespace-nowrap'])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.gallery.photos_count) + " " + _toDisplayString(_ctx.$t('files_controls_menu.files_count')) + " ", 1),
                          _createElementVNode("strong", _hoisted_21, _toDisplayString(_ctx.storageUsed), 1)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}